export default [
    {
      reducerKey: 'agency',
      sagaKey: 'agencyCardSaga',
      importReducer: () => import(/* webpackChunkName: "domain-agency" */ 'modules/Agency/AgencyCard/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-agency" */ 'modules/Agency/AgencyCard/store/saga'),
    },
    {
      reducerKey: 'agency/clients',
      sagaKey: 'agencyClientsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-agency" */ 'modules/Agency/Clients/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-agency" */ 'modules/Agency/Clients/store/saga'),
    },
    {
      reducerKey: 'agency/requests',
      sagaKey: 'agencyRequestsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-agency" */ 'modules/Agency/Requests/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-agency" */ 'modules/Agency/Requests/store/saga'),
    },
    {
      reducerKey: 'countries',
      sagaKey: 'countriesSaga',
      routeKeys: ['agency/add-agency'],
      importReducer: () => import(/* webpackChunkName: "domain-agency" */ 'modules/Countries/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-agency" */ 'modules/Countries/store/saga'),
    },
]
